<p
  *ngIf="aggregatedJobData.totalDirect !== null"
  class="counter"
>{{aggregatedJobData.totalDirect}}</p>
<div class="content">
  <div>
    <span class="color-indicator"></span>
    <span class="align-middle phase-text-styling">In review</span>
  </div>
  <div>
    <span class="color-indicator shortlisted"></span>
    <span class="align-middle phase-text-styling">Shortlisted</span>
  </div>
  <div>
    <span class="color-indicator rejected"></span>
    <span class="align-middle phase-text-styling">Rejected</span>
  </div>
</div>
<div class="content">
  <div>
    <span
      class="align-middle phase-text-styling number-style">{{aggregatedJobData.inReviewDirect}}</span>
  </div>
  <div>
    <span
      class="align-middle phase-text-styling number-style">{{aggregatedJobData.shortlisted}}</span>
  </div>
  <div>
    <span
      class="align-middle phase-text-styling number-style">{{aggregatedJobData.rejected}}</span>
  </div>
</div>
